import React from "react"
import ProtectedRoute from "./components/auth/ProtectedRoute"
import AdminRoute from "./components/auth/AdminRoute"
import Login from "./pages/Login"
import Dashboard from "./pages/Dashboard"
import InspectionsList from "./pages/InspectionsList"
import InspectionDetails from "./pages/InspectionDetails"
import UsersSearch from "./pages/UsersSearch"
import UserDetails from "./pages/UserDetails"

// Route configuration with additional metadata
export const routeConfig = {
  login: {
    path: "/login",
    name: "Login",
    element: <Login />,
    protected: false
  },
  dashboard: {
    path: "/",
    name: "Αρχική",
    element: <Dashboard />,
    protected: true
  },
  inspections: {
    path: "/inspections",
    name: "Έλεγχοι",
    icon: "fa-clipboard-list",
    element: <InspectionsList />,
    protected: true
  },
  inspectionDetails: {
    path: "/inspections/:inspectionId",
    name: "Έλεγχος",
    icon: "fa-clipboard-list",
    element: <InspectionDetails />,
    protected: true
  },
  dynamicInspection: {
    path: "/dynamic-inspection",
    name: "Δυναμικός Έλεγχος",
    icon: "fa-clipboard-list",
    element: <InspectionDetails dynamic={true} />,
    protected: true
  },
  usersSearch: {
    path: "/users",
    name: "Χρήστες",
    icon: "fa-users",
    element: <UsersSearch />,
    protected: true,
    adminOnly: true
  },
  userDetails: {
    path: "/users/:userId",
    name: "Χρήστης",
    element: <UserDetails />,
    protected: true,
    adminOnly: true
  },
  profile: {
    path: "/profile",
    name: "Προφίλ",
    element: <UserDetails />,
    protected: true
  }
}

// Generate routes for React Router
export const generateRoutes = () => {
  const notFoundRoute = {
    path: "*",
    element: (
      <div className="min-vh-100 d-flex justify-content-center align-items-center">
        <div className="text-center">
          <h1 className="display-1">404</h1>
          <p className="lead">Η σελίδα δε βρέθηκε</p>
          <a href="/" className="btn btn-primary">
            Επιστροφή στην αρχική
          </a>
        </div>
      </div>
    ),
    protected: false
  }

  // Process routes to add protection wrappers
  const processedRoutes = Object.values(routeConfig).map(route => {
    if (!route.protected) {
      return route
    }

    // For admin routes
    if (route.adminOnly) {
      return {
        ...route,
        element: <AdminRoute>{route.element}</AdminRoute>
      }
    }

    // For regular protected routes
    return {
      ...route,
      element: <ProtectedRoute>{route.element}</ProtectedRoute>
    }
  })

  return [...processedRoutes, notFoundRoute]
}

// Helper function to get route name by path
export const getRouteNameByPath = path => {
  // First try exact match
  const exactRoute = Object.values(routeConfig).find(route => route.path === path && route.element)
  if (exactRoute) return exactRoute.name

  // If no exact match, try to match dynamic routes
  const pathParts = path.split("/")
  const route = Object.values(routeConfig).find(route => {
    // Only consider routes that have an element
    if (!route.element) return false

    const routeParts = route.path.split("/")
    if (routeParts.length !== pathParts.length) return false

    return routeParts.every((part, i) => {
      if (part.startsWith(":")) return true
      return part === pathParts[i]
    })
  })

  if (!route) return "Unknown"

  // For dynamic routes, append the parameter value to the name
  const routeParts = route.path.split("/")
  const paramIndex = routeParts.findIndex(part => part.startsWith(":"))

  if (paramIndex !== -1) {
    return `${route.name} ${pathParts[paramIndex]}`
  }

  return route.name
}
